/* eslint-disable no-undef */
import Strings from "./StringSelector";

export default function Utils() {
  /*
    Returns the current height of the browser area that can render a page's content
    Offers support for older versions of Internet Explorer
  */
  this.getBrowserWindowHeight = function () {
    let windowHeight = 0;
    if (typeof (window.innerWidth) == "number") {
      //Non-IE
      windowHeight = window.innerHeight;
    } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
      //IE 6+ in 'standards compliant mode'
      windowHeight = document.documentElement.clientHeight;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
      //IE 4 compatible
      windowHeight = document.body.clientHeight;
    }
    return (windowHeight);
  };

  // Checks if the POST configuration message was received succesfully by the backend
  this.checkStatus = function (response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      let error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  };

  this.checkStatus2 = async function (response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      let errorText = await response.text();
      let error = new Error(errorText);
      error.response = response;
      throw error;
    }
  };

  // Parses the backend configuration response as a JSON
  // TODO: test removing this and putting it directly on the fetch
  this.parseJSON = function (response) {
    return response.json();
  };

  this.sortBy = function (field, reverse, primer) {

    let key = primer ?
      function (x) { return primer(x[field]); } :
      function (x) { return x[field]; };

    reverse = !reverse ? 1 : -1;

    return function (a, b) {
      // eslint-disable-next-line
      return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
    };
  };

  // Returns the uppercase of a string only if it not null or undefined
  this.treatUppercase = function (str) {
    if (undefined !== str && null !== str) {
      return str.toUpperCase();
    } else {
      return " ";
    }
  };

  // Splits the IP strings only if they are not null or undefined
  this.treatSplitting = function (str) {
    if (undefined !== str && null !== str) {
      return str.split(".").map((num) => (`000${num}`).slice(-3)).join("");
    } else {
      return " ";
    }
  };

  this.validateIPAddress = function (ipAddress) {
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipAddress)) {
      return true;
    }
    else {
      return false;
    }
  };

  this.validateSubmask = function (submask) {
    // eslint-disable-next-line
    let submaskRegex = new RegExp("^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$");
    return (submaskRegex.test(submask));
  };

  // Returns true if the IP is localhost (127.0.0.1)
  this.isIPLoopback = function (ipAddress) {
    if (ipAddress === "127.0.0.1") {
      return true;
    }
    else {
      return false;
    }
  };

  /// ---------------- Adjust Chart Height ----------------
  this.adjustChartHeight = function () {
    const browserHeight = this.getBrowserWindowHeight();

    if (browserHeight >= 950) {
      return "600px";
    }
    else if (browserHeight >= 800 && browserHeight < 950) {
      return "540px";
    }
    else if (browserHeight >= 600 && browserHeight < 800) {
      return "400px";
    }
    else {
      return "250px";
    }
  };

  this.adjustControlsContainerHeight = function () {
    const browserHeight = this.getBrowserWindowHeight();

    if (browserHeight >= 950) {
      return "680px";
    }
    else if (browserHeight >= 800 && browserHeight < 950) {
      return "620px";
    }
    else if (browserHeight >= 600 && browserHeight < 800) {
      return "530px";
    }
    else {
      return "250px";
    }
  };

  this.getPAFormatedAmplitudeForFaded = function (deviceAmplitude, hasWaveProblem) {
    if (deviceAmplitude > 0) {
      let sum = 0;
      let num = deviceAmplitude;
      let numString = num.toString();

      for (let k = 0; k < numString.length; k++) {
        sum += parseInt(numString[k], 10);
      }

      if (hasWaveProblem) {
        if (sum % 2 === 0) {
          if (num === 649 || num === 449 || num === 1099 || num === 1399) {
            num = num - 1;
          }
          else {
            if (numString[numString.length - 1] === "9") {
              num = num - 1;
            }
            else {
              num = num + 1;
            }
          }
        }
      }
      else {
        if (sum % 2 !== 0) {
          if (num === 649 || num === 449 || num === 1099 || num === 1399) {
            num = num - 1;
          }
          else {
            if (numString[numString.length - 1] === "9") {
              num = num - 1;
            }
            else {
              num = num + 1;
            }
          }
        }
      }

      return num;
    }
    else {
      return deviceAmplitude;
    }
  };

  this.getPABarGraphColorBasedOnValue = function (status, Constants, devices, hasWaveProblem) {
    if (status === null) {
      return;
    }
    else {
      if (status === Constants.GOOD) {
        if (hasWaveProblem) {
          return Constants.FADED_GREEN_HEX; // verde
        }
        else {
          return Constants.GREEN_HEX; // verde
        }
      }
      else if (status === Constants.ATTENTION) {
        if (hasWaveProblem) {
          return Constants.FADED_YELLOW_HEX; // amarelo
        }
        else {
          return Constants.YELLOW_HEX; // amarelo
        }
      }
      else if (status === Constants.BAD) {
        if (hasWaveProblem) {
          return Constants.FADED_RED_HEX; // vermelho
        }
        else {
          return Constants.RED_HEX; // vermelho
        }
      }
      else {
        return Constants.RED_HEX;
      }
    }
  };

  this.getPAFormatedNoiseForFaded = function (deviceNoise, hasWaveProblem) {
    if (deviceNoise > 0) {
      let sum = 0;
      let num = deviceNoise;
      let numString = num.toString();

      for (let k = 0; k < numString.length; k++) {
        sum += parseInt(numString[k], 10);
      }

      if (hasWaveProblem) {
        if (sum % 2 === 0) {
          if (numString[numString.length - 1] === "9") {
            num = num - 1;
          }
          else {
            num = num + 1;
          }
        }
      }
      else {
        if (sum % 2 !== 0) {
          if (numString[numString.length - 1] === "9") {
            num = num - 1;
          }
          else {
            num = num + 1;
          }
        }
      }

      return num;
    }
    else {
      return deviceNoise;
    }
  };

  this.getPANoiseBarGraphColorBasedOnValue = function (status, Constants, devices, hasWaveProblem) {
    if (status === null) {
      return;
    }
    else {
      if (status === Constants.GOOD) {
        if (hasWaveProblem) {
          return Constants.FADED_GREEN_HEX; // verde
        }
        else {
          return Constants.GREEN_HEX; // verde
        }
      }
      else if (status === Constants.ATTENTION) {
        if (hasWaveProblem) {
          return Constants.FADED_YELLOW_HEX; // amarelo
        }
        else {
          return Constants.YELLOW_HEX; // amarelo
        }
      }
      else if (status === Constants.BAD) {
        if (hasWaveProblem) {
          return Constants.FADED_RED_HEX; // vermelho
        }
        else {
          return Constants.RED_HEX; // vermelho
        }
      }
      else {
        return Constants.RED_HEX;
      }
    }
  };

  this.getPAFormatedJitterForFaded = function (deviceJitter, hasWaveProblem) {
    if (deviceJitter > 0) {
      let sum = 0;
      let num = parseFloat((deviceJitter * 100).toFixed(0));
      let numString = num.toString();

      for (let k = 0; k < numString.length; k++) {
        sum += parseInt(numString[k], 10);
      }

      if (hasWaveProblem) {
        if (sum % 2 === 0) {
          if (numString[numString.length - 1] === "9") {
            num = num - 1;
          }
          else {
            num = num + 1;
          }
        }
      }
      else {
        if (sum % 2 !== 0) {
          if (numString[numString.length - 1] === "9") {
            num = num - 1;
          }
          else {
            num = num + 1;
          }
        }
      }

      return (num / 100).toFixed(2);
    }
    else {
      return deviceJitter;
    }
  };

  this.getPAJitterBarGraphColorBasedOnValue = function (status, Constants, devices, hasWaveProblem) {
    if (status === null) {
      return;
    }
    else {
      if (status === Constants.GOOD) {
        if (hasWaveProblem) {
          return Constants.FADED_GREEN_HEX; // verde
        }
        else {
          return Constants.GREEN_HEX; // verde
        }
      }
      else if (status === Constants.ATTENTION) {
        if (hasWaveProblem) {
          return Constants.FADED_YELLOW_HEX; // amarelo
        }
        else {
          return Constants.YELLOW_HEX; // amarelo
        }
      }
      else if (status === Constants.BAD) {
        if (hasWaveProblem) {
          return Constants.FADED_RED_HEX; // vermelho
        }
        else {
          return Constants.RED_HEX; // vermelho
        }
      }
      else {
        return Constants.RED_HEX;
      }
    }
  };

  this.getPAFormatedUnbalanceForFaded = function (deviceUnbalance, hasWaveProblem) {
    if (deviceUnbalance > 0) {
      let sum = 0;
      let num = deviceUnbalance;
      let numString = num.toString();

      for (let k = 0; k < numString.length; k++) {
        sum += parseInt(numString[k], 10);
      }

      if (hasWaveProblem) {
        if (sum % 2 === 0) {
          if (numString[numString.length - 1] === "9") {
            num = num - 1;
          }
          else {
            num = num + 1;
          }
        }
      }
      else {
        if (sum % 2 !== 0) {
          if (numString[numString.length - 1] === "9") {
            num = num - 1;
          }
          else {
            num = num + 1;
          }
        }
      }

      return (num / 100).toFixed(2);
    }
    else {
      return deviceUnbalance;
    }
  };

  this.getPAUnbalanceBarGraphColorBasedOnValue = function (status, Constants, devices, hasWaveProblem) {
    if (status === null) {
      return;
    }
    else {
      if (status === Constants.GOOD) {
        if (hasWaveProblem) {
          return Constants.FADED_GREEN_HEX; // verde
        }
        else {
          return Constants.GREEN_HEX; // verde
        }
      }
      else if (status === Constants.ATTENTION) {
        if (hasWaveProblem) {
          return Constants.FADED_YELLOW_HEX; // amarelo
        }
        else {
          return Constants.YELLOW_HEX; // amarelo
        }
      }
      else if (status === Constants.BAD) {
        if (hasWaveProblem) {
          return Constants.FADED_RED_HEX; // vermelho
        }
        else {
          return Constants.RED_HEX; // vermelho
        }
      }
      else {
        return Constants.RED_HEX;
      }
    }
  };

  this.ipToBinary = (ip) => {
    return ip.split(".")
      .map(octet => parseInt(octet, 10).toString(2).padStart(8, "0"))
      .join(".");
  };

  this.calculateNetworkAddress = (ip, subnetMask, UtilsInstance) => {
    const ipBinary = UtilsInstance.ipToBinary(ip).split(".");
    const maskBinary = UtilsInstance.ipToBinary(subnetMask).split(".");
    const networkAddress = ipBinary.map((octet, index) => {
      return (parseInt(octet, 2) & parseInt(maskBinary[index], 2)).toString(2).padStart(8, "0");
    }).join(".");

    return networkAddress;
  };

  this.isSameNetwork = (ip1, ip2, subnetMask, UtilsInstance) => {
    const networkAddress1 = UtilsInstance.calculateNetworkAddress(ip1, subnetMask, UtilsInstance);
    const networkAddress2 = UtilsInstance.calculateNetworkAddress(ip2, subnetMask, UtilsInstance);
    return networkAddress1 === networkAddress2;
  };

  this.ipToInteger = (ip) => {
    return ip.split(".").reduce((int, octet) => (int << 8) + parseInt(octet, 10), 0);
  };

  this.calculateRange = (subnetIp, mask, UtilsInstance) => {
    const networkAddress = UtilsInstance.calculateNetworkAddress(subnetIp, mask, UtilsInstance);
    const invertedMask = mask.split(".").map(octet => 255 - parseInt(octet, 10)).join(".");
    const networkInt = UtilsInstance.ipToInteger(networkAddress.split(".").map(octet => parseInt(octet, 2).toString(10)).join("."));
    const broadcastInt = networkInt + UtilsInstance.ipToInteger(invertedMask);
    return [networkInt, broadcastInt];
  };

  this.subnetsOverlap = (subnetIp1, mask1, subnetIp2, mask2, UtilsInstance) => {
    const [range1Start, range1End] = this.calculateRange(subnetIp1, mask1, UtilsInstance);
    const [range2Start, range2End] = this.calculateRange(subnetIp2, mask2, UtilsInstance);
    return range1Start <= range2End && range2Start <= range1End;
  };

  // Funções para o cálculo de endereço de broadcast e endereço da rede
  this.ipToBinary2 = (ip) => {
    return ip.split(".").map(function (num) {
      return ("00000000" + parseInt(num, 10).toString(2)).slice(-8);
    }).join("");
  };

  this.binaryToIp = (binary) => {
    return binary.match(/.{1,8}/g).map(function (bin) {
      return parseInt(bin, 2).toString();
    }).join(".");
  };

  this.calculateNetworkAddress2 = (ipBinary, maskBinary) => {
    let networkBinary = "";
    for (let i = 0; i < 32; i++) {
      networkBinary += (ipBinary[i] === "1" && maskBinary[i] === "1") ? "1" : "0";
    }
    return networkBinary;
  };

  this.calculateBroadcastAddress = (networkBinary, maskBinary) => {
    let broadcastBinary = "";
    for (let i = 0; i < 32; i++) {
      broadcastBinary += (maskBinary[i] === "0") ? "1" : networkBinary[i];
    }
    return broadcastBinary;
  };

  this.isBroadcastAddress = function (ip, subnetMask, UtilsInstance) {
    const ipBinary = UtilsInstance.ipToBinary2(ip);
    const maskBinary = UtilsInstance.ipToBinary2(subnetMask);
    const networkBinary = UtilsInstance.calculateNetworkAddress2(ipBinary, maskBinary);
    const broadcastBinary = UtilsInstance.calculateBroadcastAddress(networkBinary, maskBinary);
    const broadcastAddress = UtilsInstance.binaryToIp(broadcastBinary);

    console.log("broadcastAddress: ", broadcastAddress);
    return ip === broadcastAddress;
  };

  this.isNetworkAddress = function (ip, subnetMask, UtilsInstance) {
    if (ip === "0.0.0.0") {
      return false;
    }

    const ipBinary = UtilsInstance.ipToBinary2(ip);
    const maskBinary = UtilsInstance.ipToBinary2(subnetMask);
    const networkBinary = UtilsInstance.calculateNetworkAddress2(ipBinary, maskBinary);
    const networkAddress = UtilsInstance.binaryToIp(networkBinary);

    console.log("networkAddress: ", networkAddress);
    return ip === networkAddress;
  };

  this.removeLeadingZeros = (fullIpAddress, UtilsInstance) => {
    if (fullIpAddress === "") {
      console.log("IP em branco, retorna IP em branco");
      return "";
    }
    else {
      let cleanedIp = fullIpAddress.split(".").map((ipPart) => {
        return parseInt(ipPart, 10);
      }).join(".");

      if (!UtilsInstance.validateIPAddress(cleanedIp)) {
        console.log("Caso de IP invalido, retorna o próprio texto passado como entrada");
        console.log("fullIpAddress", fullIpAddress);
        return fullIpAddress;
      }
      else {
        console.log("Caso de IP valido, retorna o IP sem os zeros à esquerda");
        console.log("cleanedIp", cleanedIp);
        return cleanedIp;
      }
    }
  };

  this.validadeHostnameLength = function (hostname) {
    return (hostname.length >= 2) && (hostname.length <= 64);
  };

  // Hostname must start with a letter or a number, can have letters, numbers,
  // dot and hyphen, and must end with a letter or number
  // This validation is a simplification of the hostname regex, it is not perfect.
  // It allows for hostnames like: as...fg, which is not a valid hostname
  // However the the return of the webservice will say if the hostname was accepted or not
  this.simpleValidadeHostname = function (hostname) {
    const nameRegex = new RegExp("^[A-Za-z0-9][A-Za-z0-9/./-]*[A-Za-z0-9]$");
    return nameRegex.test(hostname);
  };

  this.isZeroIP = function (ipAddress) {
    if (ipAddress === "0.0.0.0") {
      return true;
    }
    else {
      return false;
    }
  };

  this.getMasterPrefix = function (isMaster) {
    if (isMaster) {
      return Strings.MASTER_PREFIX;
    }
  };

  this.getMasterSuffix = function (isMaster) {
    if (isMaster) {
      return Strings.MASTER_SUFFIX;
    }
    else {
      return "";
    }
  };

  this.formatDadosValue = function (value) {
    // First, ensure the value is a number
    if (typeof value !== "number") {
      return value;
    }

    // Define your thresholds for what is "too big" or "too small"
    const largeThreshold = 1000000;
    const smallThreshold = 0.0001;

    const absValue = Math.abs(value);

    // If the number is 0, format it directly.
    if (value === 0) {
      return value.toFixed(2); // "0.00"
    }

    // Use toExponential for numbers that are too large OR too small
    if (absValue > largeThreshold || absValue < smallThreshold) {
      return value.toExponential(2);
    }

    // Otherwise, the number is in a "normal" range, so use toFixed.
    return value.toFixed(2);
  };

  this.getLanguageStringFromKey = (Constants, Strings) => {
    let langKey = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    if (langKey === Constants.ES_LANG_KEY) {
      return Strings.SPANISH;
    }
    else if (langKey === Constants.EN_LANG_KEY) {
      return Strings.ENGLISH;
    }
    else {
      return Strings.PORTUGUESE;
    }
  };

}